var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgGb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.333h512V426.67H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M288 85.33h-64v138.666H0v64h224v138.666h64V287.996h224v-64H288z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M393.785 315.358L512 381.034v-65.676zm-82.133 0L512 426.662v-31.474l-143.693-79.83zm146.982 111.304l-146.982-81.664v81.664z",
  fill: "#0052b4"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M311.652 315.358L512 426.662v-31.474l-143.693-79.83z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M311.652 315.358L512 426.662v-31.474l-143.693-79.83z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M90.341 315.356L0 365.546v-50.19zm110.007 14.154v97.151H25.491z",
  fill: "#0052b4"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M143.693 315.358L0 395.188v31.474l200.348-111.304z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M118.215 196.634L0 130.958v65.676zm82.133 0L0 85.33v31.474l143.693 79.83zM53.366 85.33l146.982 81.664V85.33z",
  fill: "#0052b4"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M200.348 196.634L0 85.33v31.474l143.693 79.83z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M200.348 196.634L0 85.33v31.474l143.693 79.83z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M421.659 196.636L512 146.446v50.19zm-110.007-14.154V85.331h174.857z",
  fill: "#0052b4"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M368.307 196.634L512 116.804V85.33L311.652 196.634z"
})));

export default SvgGb;